// extracted by mini-css-extract-plugin
export default {"menus":"Menu_menus__2kv-h"};